/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface SampleOut
 */
export interface SampleOut {
  /**
   *
   * @type {string}
   * @memberof SampleOut
   */
  uuid: string;
  /**
   *
   * @type {string}
   * @memberof SampleOut
   */
  name: string;
}

/**
 * Check if a given object implements the SampleOut interface.
 */
export function instanceOfSampleOut(value: object): value is SampleOut {
  if (!('uuid' in value) || value['uuid'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function SampleOutFromJSON(json: any): SampleOut {
  return SampleOutFromJSONTyped(json, false);
}

export function SampleOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): SampleOut {
  if (json == null) {
    return json;
  }
  return {
    uuid: json['uuid'],
    name: json['name']
  };
}

export function SampleOutToJSON(value?: SampleOut | null): any {
  if (value == null) {
    return value;
  }
  return {
    uuid: value['uuid'],
    name: value['name']
  };
}
